<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Loan Request Message</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="row">
      @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
        @for (request of requestList; track request) {
          @if (request.VerifiedOn != undefined) {
            <div class="col-12" style="background-color: #5cb85c">
              <span class="p-0 m-0" style="color: white"
                ><strong>Verified by {{ request.VerifiedBy }} on {{ request.VerifiedOn | date: "dd-MM-yyyy" }}</strong></span
              >
              <button class="btn btn-info ms-1" (click)="openReviewLoanRequestModal(request)"><i class="fas fa-file-alt"></i>Review</button>
            </div>
          }
          @if (request.VerifiedOn == undefined) {
            <div class="col-12" style="background-color: black">
              <span class="p-0 m-0" style="color: white"> <strong>Please Verify Customer</strong> </span>
              <button class="btn btn-info ms-1" (click)="openReviewLoanRequestModal(request)"><i class="fas fa-file-alt"></i>Review</button>
            </div>
          }
        }
        @if (sharedService.compareResult(compareString, value) == true || sharedService.isBossAccount()) {
          <div class="col-12">
            <app-loan-request-approval [requestList]="requestList" [loanGroupId]="loanGroupId"></app-loan-request-approval>
          </div>
        }
      }
    </div>
    <app-message-clipboard [compareString]="compareString" [value]="value"></app-message-clipboard>
  </div>
</form>
